/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import { Nullable } from '@/shared/types/app.types'

@Component
export class ModuleOperationGuardMixin extends Vue {
    $_canAccessRegistry(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, ModuleOperation.REGISTRY_ACCESS)
        }
        return this.$_hasOperationInCurrentLaboratory(ModuleOperation.REGISTRY_ACCESS)
    }
    $_canAccessGrossing(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, ModuleOperation.GROSSING_ACCESS)
        }
        return this.$_hasOperationInCurrentLaboratory(ModuleOperation.GROSSING_ACCESS)
    }
    $_canAccessLaboratory(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, ModuleOperation.LABORATORY_ACCESS)
        }
        return this.$_hasOperationInCurrentLaboratory(ModuleOperation.LABORATORY_ACCESS)
    }
    $_canAccessDiagnosis(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, ModuleOperation.DIAGNOSE_ACCESS)
        }
        return this.$_hasOperationInCurrentLaboratory(ModuleOperation.DIAGNOSE_ACCESS)
    }
    $_canAccessArchive(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, ModuleOperation.ARCHIVE_ACCESS)
        }
        return this.$_hasOperationInCurrentLaboratory(ModuleOperation.ARCHIVE_ACCESS)
    }
}
